import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d450b4fa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d450b4fa')) {
      api.createRecord('d450b4fa', component.options)
    } else {
      api.reload('d450b4fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d450b4fa&", function () {
      api.rerender('d450b4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/index.vue"
export default component.exports